<template>
    <QualificationField
        :title="$t('profile.vetting.qualification.functional.expertise.title')"
        :field-author-and-date="qualification.commentOnFunctionalExpertise"
        data-testid="admin-section-tabs-qualification-comment-on-functional-expertise"
    >
        <VJoyTextarea
            v-if="profileQualificationStore.inEditMode"
            v-model="profileQualificationStore.qualificationUpdateForm.commentOnFunctionalExpertise"
            :placeholder="$t('profile.vetting.qualification.functional.expertise.comment.placeholder')"
            autogrow
            data-testid="vetting-functional-expertise-comment-edition"
        ></VJoyTextarea>
        <TextField
            v-else
            truncate
            :content="profileQualificationStore.qualificationUpdateForm.commentOnFunctionalExpertise"
            :replace-by="$t('profile.vetting.qualification.functional.expertise.comment.empty.placeholder')"
            data-testid="vetting-functional-expertise-comment"
        />
    </QualificationField>
    <QualificationField
        v-if="isListVisible"
        :title="$t('profile.vetting.qualification.functional.expertise.title.list')"
        data-testid="admin-section-tabs-qualification-functional-skill-ratings"
    >
        <SkillRatingsField
            v-model:skill-ratings="profileQualificationStore.qualificationUpdateForm.functionalSkillRatings"
            data-testid="vetting-functional-expertise-ratings-edition"
        />
    </QualificationField>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {VJoyTextarea} from '@maltjoy/core-vue';
    import SkillRatingsField from '~/components/admin-section-tabs/qualification/SkillRatingsField.vue';
    import TextField from '~/components/admin-section-tabs/qualification/TextField.vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const profileQualificationStore = useProfileQualificationStore();

    const {qualification} = storeToRefs(profileQualificationStore);

    const isListVisible = computed((): boolean => profileQualificationStore.qualificationUpdateForm.functionalSkillRatings.length > 0);
</script>
